import styled from 'styled-components';

export const FooterContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 7px 30px;
  height: 65px;
  gap: 50px;
  background-color: #f0f0f0;
  border-top: 1px solid #e0e0e0;
  position: fixed;
  bottom: 0;
  width: 100%;
  z-index: 1000;
`;

export const FooterText = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #333;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    font-size: 14px;
  }
`;

export const FooterLogo = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const FooterLogoImage = styled.img<{ height: number }>`
  width: auto;
  height: ${({ height }) => height}px;

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}) {
    height: ${({ height }) => height * 0.8}px;
  }
`;

export const LogoItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
